import React from 'react'
import { Box, Modal } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'
import { useDispatch, useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { resendLink } from './state/actions'
import ModalContent from './ModalContent'

interface NewModalProps {
  open: boolean
  handleClose: () => void
  custNo: string
  status: string
  Email: string
  shipToLoc: string
  appId: number
  custEosId: string
  setLoading: (val: boolean) => void
}

const ResetActivationModal: React.FC<NewModalProps> = ({
  open,
  handleClose,
  custNo,
  status,
  Email,
  shipToLoc,
  appId,
  custEosId,
  setLoading
}) => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const loggedUserInfo = useSelector((state: IRootReducerState) => state.auth.user)
  const loggedUser = loggedUserInfo ? { role: loggedUserInfo['custom:role'], email: loggedUserInfo.email } : { role: null, email: null }
  const dispatch = useDispatch()

  const handleYesClick = async () => {
    setLoading(true)
    const salesRepEmail = loggedUser?.email ?? ''
    try {
      const emailsResendStatus = await dispatch(resendLink(custNo, shipToLoc, salesRepEmail, appId, custEosId))
      if (emailsResendStatus.Data === 'SUCCESS') {
        handleClose()
        notifier.success(t('AppLabels.emailResendSuccess'))
        setLoading(false)
      } else if (emailsResendStatus.Data === 'INVALID') {
        handleClose()
        notifier.error(t('AppLabels.functionNotValid'))
        setLoading(false)
      }
    } catch (error) {
      console.error('Error resending link:', error)
      handleClose()
      setLoading(false)
      notifier.error(t('AppLabels.emailResendError'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal open={open} onClose={handleClose} data-testid='reset_modal'>
      <Box className='modal-box'>
        <ModalContent status={status} email={Email} handleClose={handleClose} handleYesClick={handleYesClick} />
      </Box>
    </Modal>
  )
}

export default ResetActivationModal
